'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = routeListener;

var _actionCreaters = require('./action-creaters');

var _router = require('./router');

var _router2 = _interopRequireDefault(_router);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function routeListener($rootScope, $location, $ngRedux) {
  $rootScope.$on('$routeChangeSuccess', function () {
    $ngRedux.dispatch((0, _actionCreaters.routeChangeSuccess)((0, _router2.default)($location)));
  });
}

routeListener.$inject = ['$rootScope', '$location', '$ngRedux'];


//////////////////
// WEBPACK FOOTER
// ../node_modules/ng-redux-route/lib/route-listener.js
// module id = 918
// module chunks = 0